<template>
  <td class="table-duration-cell" :class="{ true: boolean, false: !boolean }">
    {{ duration }}
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

function formatDuration(seconds) {
  // Round to handle floating point values
  const totalSeconds = Math.round(seconds);

  // Calculate hours, minutes, and remaining seconds
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const remainingSeconds = totalSeconds % 60;

  // Format the output with padding
  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
  } else {
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  }
}

export default {
  mixins: [TableCellMixin],
  computed: {
    duration() {
      return formatDuration(this.value);
    },
  },
};
</script>
<style scoped lang="scss">
td {
  text-align: center;
  opacity: 0.5;
  font-size: 0.9em;
}
</style>
